module.exports = __webpack_public_path__ + "static/media/elrancho_logo2.2e47fd6f.png";